<template>
  <div class="row">
    <div class="alert alert-danger" role="alert" v-show="message">
      {{ message }}
    </div>
    <div class="col-lg-12">
      <!-- Edit profile picture -->
      <!-- h4><i class="fa fa-address-card fa-fw text-muted"></i> Avatar</h4 -->
      <div class="avatar">
        <img :src="imgData.src" width="150" height="150" />
        <div class="btn-group text-center m-l-40">
          <a href="#" class="btn btn-primary get-started rounded-pill tores" @click="toggleShow"> Change </a>
          <a
            v-if="imgData.hasAvatar"
            href="#"
            class="btn btn-white rounded-pill tores"
            @click="deletePicture" style="margin-left: 3px;"
          >
            Delete
          </a>
        </div>
      </div>
      <avatar-upload field="avatar" @crop-success="cropSuccess" @crop-upload-success="cropUploadSuccess" @crop-upload-fail="cropUploadFail" v-model="show" :width="128" :height="128" :url="uploadUrl" lang-type="en" :headers="headers" img-format="png"></avatar-upload>
      <!-- Edit profile informations -->
      <!-- h4><i class="fa fa-universal-access fa-fw text-muted"></i> Account Settings</h4 -->
      <hr>
      <div class="form-group row m-b-15">
        <label for="username-input" class="col-lg-3 col-form-label">Username</label>
        <div class="col-lg-7">
          <input class="form-control" type="text" v-model="user.nickname" id="username-input" :class="{'is-invalid': $v.user.nickname.$error}" @input="$v.user.nickname.$touch()">
          <div v-if="$v.user.nickname.$error" :class="{'invalid-feedback': $v.user.nickname.$error}">This username is not valid, use alphanumeric only and the min length is 5 chars</div>
        </div>
      </div>
      <div class="form-group row m-b-15">
        <label for="firstname-input" class="col-lg-3 col-form-label">Firstname</label>
        <div class="col-lg-7">
          <input class="form-control" type="text" v-model="user.firstName" id="firstname-input" :class="{'is-invalid': $v.user.firstName.$error}" @input="$v.user.firstName.$touch()">
          <div v-if="$v.user.firstName.$error" :class="{'invalid-feedback': $v.user.firstName.$error}">Firstname is not valid, use alpha only</div>
        </div>
      </div>
      <div class="form-group row m-b-15">
        <label for="lastname-input" class="col-lg-3 col-form-label">Lastname</label>
        <div class="col-lg-7">
          <input class="form-control" type="text" v-model="user.lastName" id="lastname-input" :class="{'is-invalid': $v.user.lastName.$error}" @input="$v.user.lastName.$touch()">
          <div v-if="$v.user.lastName.$error" :class="{'invalid-feedback': $v.user.lastName.$error}">Lastname is not valid, use alpha only</div>
        </div>
      </div>
      <div class="form-group row m-b-15">
        <label for="email-input" class="col-lg-3 col-form-label">Email</label>
        <div class="col-lg-7">
          <input class="form-control" type="email" v-model="user.email" id="email-input" disabled>
        </div>
      </div>
      <div class="form-group row m-b-15">
        <label for="phone-input" class="col-lg-3 col-form-label">Mobile</label>
        <div class="col-lg-7">
          <input class="form-control" type="tel" v-model="user.phone" id="phone-input">
        </div>
      </div>
      <hr>
      <div class="form-group row m-b-15">
        <label for="company-input" class="col-lg-3 col-form-label">Company</label>
        <div class="col-lg-7">
          <input class="form-control" type="text" v-model="user.company" id="company-input">
        </div>
      </div>
      <div class="form-group row m-b-15">
        <label for="website-input" class="col-lg-3 col-form-label">Website</label>
        <div class="col-lg-7">
          <input class="form-control" type="text" v-model="user.website" id="website-input">
        </div>
      </div>
      <div class="form-group row m-b-15">
        <label for="country-input" class="col-lg-3 col-form-label">Country</label>
        <div class="col-lg-7">
          <input class="form-control" type="text" v-model="user.country" id="country-input" :class="{'is-invalid': $v.user.country.$error}" @input="$v.user.country.$touch()">
          <div v-if="$v.user.country.$error" :class="{'invalid-feedback': $v.user.country.$error}">Country is not valid, use alpha only</div>
        </div>
      </div>
      <div class="form-group row m-b-15">
        <label for="city-input" class="col-lg-3 col-form-label">City</label>
        <div class="col-lg-7">
          <input class="form-control" type="text" v-model="user.city" id="city-input" :class="{'is-invalid': $v.user.city.$error}" @input="$v.user.city.$touch()">
        </div>
      </div>
      <div class="form-group row m-b-15">
        <label for="zipcode-input" class="col-lg-3 col-form-label">ZIP Code</label>
        <div class="col-lg-7">
          <input class="form-control" type="text" v-model="user.zipCode" id="zipcode-input">
        </div>
      </div>
      <!-- h4><i class="fa fa-wpforms fa-fw text-muted"></i> Specialists</h4 -->
      <hr>
      <div class="row">
        <div class="col-lg-4"><b>Professional Activities</b>
          <div class="form-check" v-bind:key="pa" v-for="pa in professionalActivities">
            <div class="checkbox checkbox-css checkbox-success">
              <input type="checkbox" :id="`cssCheckbox_${pa}`" v-model="user.professionalActivities" :value="pa">
              <label :for="`cssCheckbox_${pa}`" class="text-capitalize">{{ pa }}</label>
            </div>
          </div>
        </div>
        <div class="col-lg-4"><b>Clinical Area</b>
          <div class="form-check" v-bind:key="clinicalArea" v-for="clinicalArea in clinicalAreas">
            <div class="checkbox checkbox-css checkbox-success">
              <input type="checkbox" :id="`cssCheckbox_${clinicalArea}`" v-model="user.clinicalAreas" :value="clinicalArea">
              <label :for="`cssCheckbox_${clinicalArea}`" class="text-capitalize">{{ clinicalArea }}</label>
            </div>
          </div>
        </div>
        <div class="col-lg-4"><b>Modality</b>
          <div class="form-check" v-bind:key="mod" v-for="mod in modalities">
            <div class="checkbox checkbox-css checkbox-success">
              <input type="checkbox" :id="`cssCheckbox_${mod}`" v-model="user.modalities" :value="mod">
              <label :for="`cssCheckbox_${mod}`" class="text-capitalize">{{ mod }}</label>
            </div>
          </div>
        </div>
      </div>
      <hr>
    </div>
    <!-- div class="form-check m-t-20 col-lg-12">
      <label class="form-check-label">
        <input class="form-check-input" type="checkbox" v-model="user.newsletter"> Subscribe to our newsletter
      </label>
    </div -->
    <div class="form-group m-t-20 text-center col-lg-12">
      <button type="submit" class="btn btn-primary get-started rounded-pill" style="border-radius: 20px;" v-on:click.stop.prevent="save()">Submit</button>
      <router-link role="button" type="cancel" class="btn btn-white rounded-pill" :to="{ name: 'Profile'}" style="border-radius: 20px;">Cancel</router-link>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import types from '@/store/mutation-types'
import AvatarUpload from 'vue-image-crop-upload'
import { validationMixin } from 'vuelidate'
import { required, alpha, minLength } from 'vuelidate/lib/validators'

export default {
  name: 'EditProfile',
  components: { 'avatar-upload': AvatarUpload },
  data() {
    return {
      user: {},
      professionalActivities: ['physician', 'radiologist', 'researcher', 'software developper'],
      modalities: ['mri', 'ultrasound', 'xray', 'ct', 'pet', 'EEG', 'ECG'],
      clinicalAreas: ['cardiology', 'vascular', 'neurology', 'oncology', 'dental'],
      message: null,
      show: false,
      headers: {
        smail: '*_~'
      },
      uploadUrl: `${Vue.http.options.root}/media`,
      imgData: {
        src: '/beta/static/default-user-128.png',
        hasAvatar: false
      }
    }
  },
  mixins: [validationMixin],
  validations: {
    user: {
      nickname: {
        required,
        minLength: minLength(5)
      },
      lastName: {
        alpha
      },
      firstName: {
        alpha
      },
      country: {
        alpha
      },
      city: {
        alpha
      }
    }
  },
  created: function() {
    this.fetchData()
  },
  methods: {
    fetchData: function() {
      this.$http.get('user/me').then(
        response => {
          this.user = response.data
          if (this.user.picture) this.imgData = { src: this.$options.filters.media(this.user.picture.slug, { width: '150' }), hasAvatar: true }
        },
        err => {
          // error callback
          this.showErrorMessage(
            'Sorry but an error occurred when retrieving your profile information :('
          )
          console.log(err)
        }
      )
    },
    hideErrorMessage() {
      this.message = null
    },
    showErrorMessage(message) {
      this.message = message
    },
    deletePicture() {
      this.user.picture = null
      this.imgData = { src: '/beta/static/default-user-128.png', hasAvatar: false }
    },
    save() {
      this.hideErrorMessage()
      if (!this.$v.$invalid) {
        this.$http.post('user/me', this.user).then(
          response => {
            this.user = response.data
            this.$store.commit(types.USER_LOADED, response.data)
            this.$router.push({ name: 'Profile' })
          },
          err => {
            // error callback
            this.showErrorMessage(
              'Sorry but an error occurred when submitting form'
            )
            console.log(err)
          }
        )
      } else {
        this.showErrorMessage(
          'Form is not valid, please fill all fields following requirements'
        )
      }
    },
    toggleShow() {
      this.show = !this.show
    },
    cropSuccess(imgDataUrl, field) {
      this.imgData = { src: imgDataUrl, hasAvatar: true }
    },
    cropUploadSuccess(jsonData, field) {
      this.user.picture = jsonData
    },
    cropUploadFail(status, field) {
      console.log(status)
    }
  }
}
</script>
<style scoped>
.form-check {
  padding-left: 0rem;
}
.form-check-label {
  font-weight: 400;
}
.m-l-40 {
  margin-left: 40px !important;
}
.m-b-15 {
  margin-bottom: 15px !important;
}


.checkbox.checkbox-css {
  position: relative;
  line-height: 16px;
  padding-top: 7px;
}
.checkbox, .radio {
    position: relative;
    display: block;
    margin-top: 10px;
    margin-bottom: 10px;
}
</style>
<style scoped>
.nav > li > a {
  padding: 10px 15px;
}
.nav > li,
.nav > li > a {
  position: relative;
  display: block;
  width: 100%;
}
@media (max-width: 767px){
  .tores {
    margin-top: 1em;
  }
}
</style>
<style>
.get-started {
  background: #E95913 !important;
}
.get-started:hover {
  background:  #E95913af !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/profile/EditProfile.vue